export default __webpack_public_path__ + "static/media/IMG_20211224_221803.a5debaca.png";